import CommonRouterSection from '@/components/layout/CommonRouterSection'

export default {
  path: '/my',
  name: 'my',
  component: CommonRouterSection,
  children: [  
    {
      path: 'query',
      name: 'query',
      component: () => import('@/views/my/Query.vue')
    },
    {
      path: 'memo',
      name: 'memo',
      component: () => import('@/views/my/Memo.vue')
    },
    {
      path: 'bookmark',
      name: 'bookmark',
      component: () => import('@/views/my/Bookmark.vue')
    },
  ]
}
